// ============================================================
// home-search/geolocation.js — Botón de ubicación y reverse geocoding
// ============================================================

/**
 * Crea el botón "Ubicación" junto al campo de ciudad
 * Usa Nominatim (OpenStreetMap) para reverse geocoding gratuito
 * @param {HTMLInputElement} inputCiudad - El input de ciudad
 */
export function createUseLocationButton(inputCiudad) {
  try {
    const fields = document.querySelectorAll('.search-card .search-field');
    const cityField = fields && fields[2];
    if (!cityField) return;

    const btn = document.createElement('button');
    btn.type = 'button';
    btn.textContent = 'Ubicación';
    btn.className = 'use-location-btn';
    cityField.classList.add('city-field');

    const cityInput = inputCiudad;
    if (cityInput && cityInput.parentElement === cityField) {
      cityInput.insertAdjacentElement('afterend', btn);
    } else {
      cityField.appendChild(btn);
    }

    btn.addEventListener('click', async () => {
      btn.disabled = true;
      const prev = btn.textContent;
      btn.textContent = 'Obteniendo…';
      const restore = () => { btn.disabled = false; btn.textContent = prev; };

      try {
        if (!('geolocation' in navigator)) {
          alert('La geolocalización no está disponible en este navegador.');
          restore();
          return;
        }

        const position = await new Promise((resolve, reject) => {
          navigator.geolocation.getCurrentPosition(resolve, reject, {
            enableHighAccuracy: true,
            timeout: 8000,
            maximumAge: 60000
          });
        });

        const { latitude, longitude } = position.coords;
        try {
          localStorage.setItem('user_location', JSON.stringify({ lat: latitude, lon: longitude, ts: Date.now() }));
        } catch (_) {}

        let city = '';
        let country = '';
        let composed = '';

        try {
          const geoUrl = `https://nominatim.openstreetmap.org/reverse?format=json&lat=${latitude}&lon=${longitude}&accept-language=es`;
          const geoRes = await fetch(geoUrl);
          if (geoRes.ok) {
            const geoData = await geoRes.json();
            const address = geoData.address || {};

            let rawCity = address.city || address.town || address.village || address.municipality ||
                          address.county || address.state_district || '';

            if (rawCity) {
              city = rawCity
                .replace(/Perímetro Urbano\s+/i, '')
                .replace(/Municipio de\s+/i, '')
                .replace(/Distrito de\s+/i, '')
                .trim();
            }

            country = address.country || 'Colombia';
            composed = country ? `${city}, ${country}` : city;
          }
        } catch (e) {
          console.log('Error en reverse geocoding:', e);
        }

        if (!city) {
          city = 'Bucaramanga';
          country = 'Colombia';
          composed = `${city}, ${country}`;
        }

        if (city) {
          inputCiudad.value = composed;
          try { localStorage.setItem('user_city', composed); } catch (_) {}
          const ev = new Event('input');
          inputCiudad.dispatchEvent(ev);
        } else {
          alert('No pudimos determinar tu ciudad. Por favor, escribe tu ciudad manualmente.');
        }
      } catch (e) {
        const msg = e && e.message ? e.message : 'No se pudo obtener tu ubicación.';
        alert(`${msg}. Por favor, escribe tu ciudad manualmente.`);
      } finally {
        restore();
      }
    });
  } catch (_) { /* noop */ }
}
